import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { PATH_DASHBOARD } from "src/routes/paths";
import LoadingScreen from "../components/LoadingScreen";
import useAuth from "../hooks/useAuth";
import LandingPage from "src/components/root_page/newLandingPage/index";
import { TIME_OUT } from "src/config";
import { useIdleTimer } from "react-idle-timer";
import { clearSession } from "src/utils/jwt";

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();
  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState(null);

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      clearSession();
      setRequestedLocation(pathname);
    }
    return <LandingPage />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}

export const AdminGuard = ({ children }) => {
  const { isAdmin, isSubAdmin, logout } = useAuth();

  const IDLE_TIMEOUT = TIME_OUT;
  const handleLogout = () => {
    logout();
  };

  const { reset } = useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleLogout,
    debounce: 250, // Optional: debounce idle events
  });

  useEffect(() => {
    const handleActivity = () => {
      reset();
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);
    window.addEventListener("click", handleActivity);
    window.addEventListener("touchstart", handleActivity);
    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.addEventListener("touchstart", handleActivity);
    };
  }, [reset]);
  if (isAdmin || isSubAdmin) {
    return <>{children}</>;
  }
  return <Navigate to="/user" />;
};

export const SubAdminGuard = ({ children }) => {
  const { isSubAdmin } = useAuth();

  if (isSubAdmin) {
    return <Navigate to={PATH_DASHBOARD.dashboard.root} />;
  }

  return <>{children}</>;
};

export const UserGuard = ({ children }) => {
  const { isAdmin, isSubAdmin, logout } = useAuth();
  const IDLE_TIMEOUT = TIME_OUT;
  const handleLogout = () => {
    logout();
  };

  const { reset } = useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleLogout,
    debounce: 250, // Optional: debounce idle events
  });

  useEffect(() => {
    const handleActivity = () => {
      reset();
    };

    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keypress", handleActivity);
    window.addEventListener("click", handleActivity);
    window.addEventListener("touchstart", handleActivity);
    return () => {
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keypress", handleActivity);
      window.removeEventListener("click", handleActivity);
      window.addEventListener("touchstart", handleActivity);
    };
  }, [reset]);
  if (isAdmin || isSubAdmin) {
    return <Navigate to="/admin" />;
  }

  return <>{children}</>;
};
